/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Queue_Wrapuptimeseconds_Min3Inputs */

const en_queue_wrapuptimeseconds_min3 = /** @type {(inputs: Queue_Wrapuptimeseconds_Min3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Must be >= 0`)
};

const de_queue_wrapuptimeseconds_min3 = /** @type {(inputs: Queue_Wrapuptimeseconds_Min3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Muss >= 0 sein`)
};

/**
* | output |
* | --- |
* | "Must be >= 0" |
*
* @param {Queue_Wrapuptimeseconds_Min3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const queue_wrapuptimeseconds_min3 = /** @type {((inputs?: Queue_Wrapuptimeseconds_Min3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Queue_Wrapuptimeseconds_Min3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_queue_wrapuptimeseconds_min3(inputs)
	return de_queue_wrapuptimeseconds_min3(inputs)
});
export { queue_wrapuptimeseconds_min3 as "queue_wrapUpTimeSeconds_min" }